var React = require('react');

function Notfound (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"69.6247","cy":"54.6247","r":"3.62466","fill":"#C3CED3","key":0}),React.createElement("circle",{"cx":"123.477","cy":"54.6247","r":"3.62466","fill":"#C3CED3","key":1}),React.createElement("path",{"d":"M90.8547 77.4082C92.4657 75.6504 94.9081 74.3014 98.13 74.3014C101.352 74.3014 104.106 75.9775 105.353 77.4082","stroke":"#C3CED3","strokeWidth":"4","strokeLinecap":"round","key":2}),React.createElement("rect",{"x":"2","y":"2","width":"190","height":"120","rx":"15","stroke":"#C3CED3","strokeWidth":"4","strokeLinecap":"round","strokeDasharray":"1 10","key":3})]);
}

Notfound.defaultProps = {"width":"194","height":"124","viewBox":"0 0 194 124","fill":"none"};

module.exports = Notfound;

Notfound.default = Notfound;
